import React from "react";
import styles from "./CommenText.module.css";

const TestTwo = () => {
  return <div className={styles.draggableTwo}>Drag Second</div>;
};

export default TestTwo;
